import { render, staticRenderFns } from "./below-the-fold.vue?vue&type=template&id=b89552e0"
import script from "./below-the-fold.vue?vue&type=script&lang=js"
export * from "./below-the-fold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports